import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { AzureApiService } from '../../services/azure-api.service';
import { DtoSaveResult } from '../../shared/models/DtoSaveResult';
import { DtoDeleteResult } from '../../shared/models/DtoDeleteResult';
import {DtoSecurityItem} from "./models/DtoSecurityItem";
import {DtoSecurityBaseItems} from "./models/DtoSecurityBaseItems";

@Injectable()
export class SettingsSecurityService {
    private apiUrl: string;
    private dtoSecurityBaseItems: DtoSecurityBaseItems;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'security';
    }

    public getSecurityItems = (): Observable<DtoSecurityItem[]> => {
        return this.http.get<DtoSecurityItem[]>(`${this.apiUrl}`);
    };

    public getSecurityItemById = (id: number): Observable<DtoSecurityItem> => {
        return this.http.get<DtoSecurityItem>(`${this.apiUrl}/${id}`);
    };

    public getSecurityItemByType = (id: number): Observable<DtoSecurityItem> => {
        return this.http.get<DtoSecurityItem>(`${this.apiUrl}/type/${id}`);
    };

    public saveSecurityItem = (dtoObject: DtoSecurityItem): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(this.apiUrl, dtoObject);
    };

    public deleteSecurityItemById = (id: number): Observable<DtoDeleteResult> => {
        return this.http.delete<DtoDeleteResult>(`${this.apiUrl}/${id}`);
    };

    public getSecurityBaseItems = (refresh: boolean): Observable<DtoSecurityBaseItems> => {
        if (!this.dtoSecurityBaseItems || refresh) {
            this.http.get<DtoSecurityBaseItems>(`${this.apiUrl}/baseitems`)
                .subscribe(response => this.dtoSecurityBaseItems = response);
            return Observable.create(observer => {
                observer.next(this.dtoSecurityBaseItems);
                observer.complete();
            });
        } else {
            return Observable.create(observer => {
                observer.next(this.dtoSecurityBaseItems);
                observer.complete();
            });
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-security/settings-security.service.ts